module.exports = __webpack_public_path__ + "media/images/beef_and_pork-0a278382a56d6785df9fe3791ba65ff0.jpg";